import { httpService } from '@/services/HttpService';

class WorkspaceService {
  create(data: any): Promise<any> {
    return httpService.post('workspaces', data);
  }
  getWorkspaces(): Promise<any> {
    return httpService.get('workspaces');
  }
  unsubscribeFromWorkspace(workspaceId: number): Promise<any> {
    return httpService.delete(`workspaces/${workspaceId}/settings/sign_out`, {});
  }
  getSettings(workspaceId: number): Promise<any> {
    return httpService.get(`workspaces/${workspaceId}/settings`, {}, { isErrorSuppressed: true });
  }
  changeRole(workspaceId: number, userId: any, role: any): Promise<any> {
    return httpService.put(`workspaces/${workspaceId}/settings/users/${userId}`, { role });
  }
  updateWorkspaceName(workspaceId: number, name: any): Promise<any> {
    return httpService.put(`workspaces/${workspaceId}/settings`, name);
  }
  removeInvitation(token: string): Promise<any> {
    return httpService.delete(`invitations/${token}`, '');
  }
  getLogs(type: string, workspaceId: number, targetId: number, page: number): Promise<any> {
    return httpService.get(
      `workspaces/${workspaceId}/audit_logs?target_type=${type}&target_id=${targetId}&page=${page}`
    );
  }
  createTicket(workspaceId: number, data: any): Promise<any> {
    return httpService.postMultipart(`workspaces/${workspaceId}/tickets`, data, {}, { isErrorSuppressed: true });
  }
  sendWorkspaceRemoveEmail(workspaceId: number) {
    return httpService.post(`workspaces/${workspaceId}/settings/request_destroy`, '');
  }
  removeWorkspace(workspaceId: number, token: string) {
    return httpService.delete(`workspaces/${workspaceId}/settings?token=${token}`, '');
  }
}

export const workspaceService = new WorkspaceService();
